import React, { memo } from 'react';
import cx from 'classnames';
import {
  arrayOf,
  bool,
  func,
  shape,
  string,
  oneOfType,
  number,
} from 'prop-types';

import UpIcon from '../../upIcon/UpIcon';

import styles from './DropdownSelect.module.css';

const propTypes = {
  id: string,
  value: oneOfType([string, number]).isRequired,
  options: arrayOf(
    shape({
      text: string.isRequired,
      value: oneOfType([string, number]).isRequired,
    })
  ).isRequired,
  onChange: func.isRequired,
  disabled: bool,
  label: string,
  required: bool,
  basicStyle: bool,
  className: string,
};

const defaultProps = {
  id: undefined,
  className: '',
  disabled: false,
  label: '',
  required: false,
  basicStyle: false,
};

const DropdownSelect = ({
  id,
  value,
  options,
  onChange,
  disabled,
  label,
  required,
  basicStyle,
  className,
}) => (
  <div className={cx(styles.root, className)}>
    {label && (
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    )}
    <div
      className={cx({
        [styles.select]: !basicStyle,
        [styles.basicSelect]: basicStyle,
        [styles.disabled]: disabled,
      })}
    >
      <select
        disabled={disabled}
        id={id}
        onChange={({ target }) => onChange(target.value)}
        required={required}
        value={value}
        aria-label={label || 'Dropdown Select'}
      >
        {options.map((o) => (
          <option
            key={o.value}
            value={o.value}
            disabled={!o.value}
            className={cx({
              [styles.option]: !basicStyle,
              [styles.basicOption]: basicStyle,
            })}
          >
            {o.text}
          </option>
        ))}
      </select>
      {!basicStyle && <UpIcon className={cx(styles.arrow)} />}
    </div>
  </div>
);

DropdownSelect.propTypes = propTypes;
DropdownSelect.defaultProps = defaultProps;
export default memo(DropdownSelect);
